module.exports = __webpack_public_path__ + "img/backside.abb6510c.png";